import px2EmSync from"px2em-sync";var px2em=function(m){return px2EmSync(m,{format:"rem",base:16})};export default px2em;export{px2em};
